import * as THREE from 'three'; 
import EventEmitter from "./EventEmitter.js";
import { GLTFLoader } from 'three/examples/jsm/Addons.js';

export default class Resources extends EventEmitter
{
    constructor(Sources)
    {
        super();
        console.log("Created Resources.");
        this.Sources = Sources;

        this.items = {};
        this.toLoad = this.Sources.length;
        this.loaded = 0;

        this.SetLoaders();
        this.StartLoading();
    }

    SetLoaders()
    {
        this.loaders = {};
        this.loaders.gltfLoader = new GLTFLoader();
        this.loaders.textureLoader = new THREE.TextureLoader();
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
    }

    StartLoading()
    {
        console.log('Resources.StartLoading()')
        for(const source of this.Sources)
        {
            switch(source.type)
            {
                case 'gltfModel':
                    this.loaders.gltfLoader.load(
                        source.path,
                        (file) => { this.SourceLoaded(source, file); }
                    )
                    break;
                case 'texture':
                    this.loaders.textureLoader.load(
                        source.path,
                        (file) => { this.SourceLoaded(source, file); }
                    )
                    break;
                case 'cubeTexture':
                    this.loaders.cubeTextureLoader.load(
                        source.path,
                        (file) => { this.SourceLoaded(source, file); }
                    );
                    break;
                default:
                    break;
            }
        }
    }

    SourceLoaded(source, file)
    {
        this.items[source.name] = file;
        this.loaded++;
        if(this.loaded === this.toLoad)
        {
            this.trigger('loaded');
        }
    }
}